<template>
  <vue-seamless-scroll :data="listData" :class-option="{limitMoveNum: 2,direction: 2,step: 0.4,}" class="warp">
    <ul class="ul-item">
      <li class="li-item" v-for="(item, index) in listData" :key="index">
        {{ item }}
      </li>
    </ul>
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'Example03Basic',
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      listData: [1, 2, 3, 4, 5, 6],
    }
  },
}
</script>

<style lang="less" scoped>
.warp {
  width: 130px * 4;
  height: 120px;

  overflow: hidden;

  .ul-item {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    display: flex;

    .li-item {
      width: 120px;
      height: 120px;
      margin-right: 10px;
      line-height: 120px;
      background-color: #999;
      color: #fff;
      text-align: center;
      font-size: 30px;
    }
  }
}
</style>